import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  getProjexts(id) {
    return httpAdminClient.get(`admin/compete/activities/${id}/projects`);
  },
  createProject(id, data) {
    return httpAdminClient.post(`admin/compete/activities/${id}/projects`, { compete_project: { ...data } });
  },
  patchProject(id, data) {
    return httpAdminClient.patch(`admin/compete/projects/${id}`, { compete_project: { ...data } });
  },
  deleteProject(id) {
    return httpAdminClient.delete(`admin/compete/projects/${id}`);
  },
  copy(id, data) {
    return httpAdminClient.post(`admin/compete/projects/${id}/copy_entries`, {
      compete_project: {
        ...data,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/compete/projectsApis.js